import styled from "@emotion/styled";

export const Root = styled.span({
    "> span": {
        "> div": {
            display: "inline-block",
            width: "100%",

            ":first-of-type": {
                display: "inline",
            },
        },
        "> a": {
            display: "inline-block",
            width: "100%",
        },
    },
});
